var $16c606e9b72a71c3$exports = {};
$16c606e9b72a71c3$exports = {
  "backButton": args => "Zur\xFCck zu ".concat(args.prevMenuButton),
  "moreActions": "Mehr Aktionen",
  "unavailable": "Nicht verf\xFCgbar, f\xFCr Details erweitern"
};
export { $16c606e9b72a71c3$exports as default };